module.exports = __webpack_public_path__ + "static/media/micro.16da628d.jpeg";